module.exports = __webpack_public_path__ + "img/item_image_5.60d191a4.jpg";